import React from 'react'
import cn from 'classnames'
import OutsideClickHandler from 'react-outside-click-handler'
// Components
import Button from '@/components/newButton/Button'
import styles from './toastModal.module.scss'

export type ModalMessageProps = {
  theme?: string
  closeToast?: () => void
  title: string
  message: string
  buttonTitle?: string
  onClick?: () => void
}

const ModalMessage = ({
  theme,
  closeToast,
  title,
  message,
  buttonTitle,
  onClick,
}: ModalMessageProps) => (
  <div
    className={cn({
      [styles.toast]: true,
      [styles[theme]]: true,
    })}
  >
    <OutsideClickHandler onOutsideClick={closeToast}>
      <div className={styles.closeButton} onClick={closeToast} />
      <div className={styles.title}>{title}</div>
      <div className={styles.message}>{message}</div>

      {!!buttonTitle && (
        <Button
          theme={['toast', 'medium']}
          title={buttonTitle}
          onClick={onClick}
        />
      )}
    </OutsideClickHandler>
  </div>
)

ModalMessage.defaultProps = {
  theme: 'success',
}

export default ModalMessage
